import { st } from "~/sassmall/i18n";
import {
  getSassmallResponseMessage,
  isSassmallResponseSuccess,
  sassmallRequest,
} from "./client";

export interface SassmallTenantExchangeRate {
  id?: string | number;
  tenantId?: string | number;
  fromCurrency?: string;
  toCurrency?: string;
  exchangeRate?: number | string;
  status?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface SassmallSystemRegion {
  id?: string | number;
  regionCode?: string;
  parentCode?: string;
  regionName?: string;
  aliasName?: string;
  regionLevel?: number;
  regionPath?: string;
  sortOrder?: number;
  status?: number;
}

export function getSassmallRegionDisplayName(region: SassmallSystemRegion) {
  return region.aliasName?.trim() || region.regionName?.trim() || region.regionCode?.trim() || "";
}

export function listSassmallSystemRegions(params: {
  countryCode?: string;
  parentId?: string;
  regionLevel?: number;
}) {
  return sassmallRequest<SassmallSystemRegion[]>("/regions", {
    method: "GET",
    query: params,
  });
}

export async function listSassmallTenantExchangeRates(fromCurrency = "CNY") {
  const response = await sassmallRequest<SassmallTenantExchangeRate[]>("/system/exchange-rates", {
    method: "GET",
    query: { fromCurrency },
    skipAuth: true,
  });

  if (!isSassmallResponseSuccess(response)) {
    throw new Error(getSassmallResponseMessage(response, st("汇率加载失败")));
  }
  return Array.isArray(response.data) ? response.data : [];
}
